import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
export const IconMailBase = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' }, d: "M17.5 5.56833V14.4317C17.5 15.185 16.8892 15.795 16.1367 15.795H3.86333C3.68427 15.7951 3.50694 15.7599 3.34148 15.6914C3.17602 15.623 3.02569 15.5225 2.89907 15.3959C2.77245 15.2693 2.67203 15.119 2.60355 14.9535C2.53508 14.7881 2.49989 14.6107 2.5 14.4317V5.56833M2.59916 5.06249L9.01083 9.64833C9.29333 9.85049 9.63193 9.95932 9.97931 9.95962C10.3267 9.95992 10.6655 9.85167 10.9483 9.64999L17.3967 5.05083" })));
};
export const IconMailOpen = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' }, d: "M2.5 5L10 1L17.5 5" })));
};
export const IconMailClose = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' }, d: "M17.5 5.56833C17.5 4.815 16.8892 4.20416 16.1358 4.20416H3.86333C3.11083 4.20416 2.5 4.815 2.5 5.56833M2.59916 5.0625L9.01083 9.64833C9.29333 9.85049 9.63193 9.95933 9.97931 9.95963C10.3267 9.95993 10.6655 9.85167 10.9483 9.65L17.3967 5.05083" })));
};
const Wrapper = styled.div `
  --open-y: 8%;
  --open-rotate: 90deg;
  --close-y: 0%;
  --close-rotate: 0deg;
  --paper-y: 0px;
  position: relative;
  display: table;
  transform-style: preserve-3d;
  svg {
    --icon-color: ${({ theme }) => theme.primary.background};
  }
`;
const Open = styled(IconMailOpen) `
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: 50% 12.5%;
  transform: translateY(var(--open-y)) rotateX(var(--open-rotate)) translateZ(0);
`;
const Close = styled(IconMailClose) `
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: 50% 12.5%;
  transform: translateY(var(--close-y)) rotateX(var(--close-rotate)) translateZ(0);
`;
const Paper = styled.div `
  position: absolute;
  inset: 0;
  clip-path: polygon(0 0, 100% 0, 100% 24%, 50% 50.5%, 0 24%);
  &:before {
    content: '';
    width: 10px;
    height: 10px;
    bottom: 0;
    left: 50%;
    position: absolute;
    transform: translate(-50%, var(--paper-y)) translateZ(0);
    border-radius: 1px;
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.primary.background};
    background-color: ${({ theme }) => theme.background};
  }
`;
export const IconMail = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            gsap.to(wrapperRef.current, {
                yoyo: true,
                repeat: 1,
                keyframes: [
                    {
                        '--close-y': '15%',
                        '--close-rotate': '90deg',
                        duration: 0.1,
                        ease: 'none',
                    },
                    {
                        '--open-y': '0%',
                        '--open-rotate': '0deg',
                        duration: 0.2,
                        ease: 'none',
                    },
                    {
                        '--paper-y': '-9px',
                        duration: 0.35,
                        ease: 'power2.out',
                    },
                ],
                onComplete: () => {
                    triggerDone();
                },
            });
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Open, null),
        React.createElement(Close, null),
        React.createElement(Paper, null),
        React.createElement(IconMailBase, null)));
};
//# sourceMappingURL=Mail.js.map